module.exports = __webpack_public_path__ + "76e8b16cdf8b8ab5515c51650168e965.svg";